// The window in which a card line belongs to the gateway rather than to the
// teller. It opens when the card form is asked for, not when the client secret
// comes back: the intent the server creates is fixed at the amount showing when
// the request goes out, and the cart check in front of that request is
// asynchronous. Both card controllers open the window at the same point and the
// checkout's own guards read the mark, so a change refused on one card line is
// refused on the other.

// Marks the line and freezes the amount the intent will be created for. The
// amount has to hold still for the whole window: an editable field leaves the
// page showing one figure while the gateway holds another, and the checkout
// would post the amount on the page against a hold the gateway never took.
export function holdCardLine(cardFields) {
    if (!cardFields) {
        return;
    }
    cardFields.dataset.cardIntent = "requested";
    tenderedFields(cardFields).forEach(function (field) {
        field.readOnly = true;
    });
}

// Hands the line back when nothing was created — a cart refused before the
// request went, or a request that failed. Leaving the hold on would lock the
// teller out of a checkout the gateway never touched.
export function releaseCardLine(cardFields) {
    if (!cardFields) {
        return;
    }
    delete cardFields.dataset.cardIntent;
    tenderedFields(cardFields).forEach(function (field) {
        field.readOnly = false;
    });
}

// Read-only rather than disabled: a disabled field is left out of the form data
// the request is built from, and the amount is the one thing the server is
// being asked to hold.
function tenderedFields(cardFields) {
    return Array.prototype.slice.call(cardFields.querySelectorAll(".tendered-field"));
}
